export class GetHistoryPricePhyParamsRequest {
  Interval: string;
  Code: string;
  StartDate: Date;
  EndDate: Date;
}
